import React, { useEffect, useState } from "react";
import { UserCard } from "../../../components/";
import { NavLink } from "react-router-dom";
import { handleApi } from "../../../utils/authentication";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import { UPDATE_USER_DATA } from "../../../redux/features/user/userSlice";
import LoadingSpinner from "../../../components/client/LoadingSpinner";
import { customStyles } from "../../../utils/select_style";
import { members } from "../client-tour/members";
import useClientTour from "../../../hooks/useClientTour";

const Users = () => {
  const [userList, setUserList] = useState([]);
  const [membersCount, setMemberCount] = useState({});
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("active_clients");
  const [filter, setFilter] = useState({ label: "All", value: 0 });
  const user = useSelector((state) => state?.user);
  // Bug fix carried with the refactor: this previously selected `state.user`
  // (typo), so the members_page "already seen" guard never fired. Selecting
  // the correct slice makes that guard work as intended.
  const tour = useSelector((state) => state?.tour);
  const dispatch = useDispatch();
  const [page_details, setPageDeatils] = useState({
    current_page: 1,
    last_page: 1,
  });

  useClientTour({
    enabled: !user?.has_seen_tour && !tour?.members_page && user?.is_client,
    steps: members,
    tourKey: "members_page",
    nextRoute: "/client/settings/add_user",
    skipRoute: "/client/settings/users",
  });

  const getUsertList = async () => {
    try {
      setLoading(true);
      let method = "POST";
      let headers = {};
      let formData = new FormData();
      formData.append("client_id", user?.client_id);
      if (activeTab === "active_clients") {
        formData.append("status", 1);
      } else if (activeTab === "blocked_clients") {
        formData.append("status", 0);
      } else {
        formData.append("status", -1);
      }

      formData.append("role", filter?.value);

      let result = await handleApi(
        `user_list?page_number=${page_details?.current_page}`,
        method,
        headers,
        formData,
      );
      if (result?.success) {
        let users = result?.data?.user_list?.filter((userDetails) => {
          if (userDetails?.user_id !== user?.user_id) {
            return userDetails;
          }
        });
        setUserList(users);
        setMemberCount({
          active: result?.data?.active_members,
          blocked: result?.data?.blocked_members,
          pending: result?.data?.pending_members,
        });
        if (
          result?.data?.total_members != user?.total_members &&
          result?.data?.total_members != null
        ) {
          dispatch(
            UPDATE_USER_DATA({ total_members: result?.data?.total_members }),
          );
        }
        setPageDeatils({
          current_page: result?.data?.current_page,
          last_page: result?.data?.last_page,
        });
      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Users not found",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          },
        );
      }
    } catch (e) {
      console.log(e);
      toast.error(e?.message ? e?.message : "Users not found", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsertList();
  }, [user?.client_id, activeTab, filter, page_details?.current_page]);


  return (
    <div className="d-flex flex-column gap_lg">
      {/* <div className="row campaign_header_tab d-flex align-items-center mb-3 ">
                <div className="col-lg-10 col-md-12  ">
                    <div className="row d-flex align-items-center ">
                        <div className="col-lg-2 col-md-4   ">
                            <span href="" onClick={() => setActiveTab('active_clients')}>
                                <p className={`mb-0 ${activeTab === "active_clients" && "campaign_header_tab_active"}`}>Active Members ({membersCount?.active})</p>
                                {activeTab === "active_clients" &&
                                    <div style={{ border: 'solid 1px #7f56d9' }} className='underline'> </div>}
                            </span>

                        </div>
                        <div className="col-lg-3 col-md-4 text-center  ">
                            <span href="" onClick={() => setActiveTab('blocked_clients')}>
                                <p className={`mb-0 ${activeTab === "blocked_clients" && "campaign_header_tab_active"}`}>Blocked Members ({membersCount?.blocked})</p>
                                {activeTab === "blocked_clients" &&
                                    <div style={{ border: 'solid 1px #7f56d9' }} className='underline'> </div>}
                            </span>

                        </div>
                        <div className="col-lg-3 col-md-4 text-center ">
                            <span href="" onClick={() => setActiveTab('pending_clients')}>
                                <p className={`mb-0 ${activeTab === "pending_clients" && "campaign_header_tab_active"}`}>Onboard Pending Members ({membersCount?.pending}) </p>
                                {activeTab === "pending_clients" &&
                                    <div style={{ border: 'solid 1px #7f56d9' }}> </div>}
                            </span>
                        </div>


                        <div className="col-lg-4 col-md-4 text-center" >
                            <div className='d-flex py-lg-1 px-3 d-flex align-items-center bg-white gap-2  rounded'>
                                <label htmlFor="">Filter User By:</label>
                                <Select
                                    onChange={(selected_option) => {
                                        setFilter(selected_option)
                                    }}
                                    value={filter}
                                    styles={customStyles}
                                    isSearchable={true}
                                    options={[{ label: 'All', value: 0 }, { label: 'Admin', value: 1 }, { label: 'Member', value: 3 }]}
                                />

                            </div>



                        </div>

                    </div>



                </div>
                {((user?.role_id === 2 || user?.role_id === 1) && user?.total_members > (membersCount?.active+membersCount?.pending)) &&
                    <div className="col-lg-2 d-flex justify-content-lg-end">
                        <NavLink style={{ marginRight: '-6vw' }} to="/client/add_user" className="btn btn-md  rounded-pill text-center  btn-primary nav_export_stats_btn">Create Member</NavLink>

                    </div>}
                {activeTab === "pending_clients" &&
                    <div style={{
                        fontFamily: 'aeonik_medium'
                    }}>
                        <p className='my-2'>Once the member completes onboarding process it will be listed in <span className='text-success '>Active Members List.</span> </p>
                    </div>}

            </div> */}

      <div className="row campaign_header_tab d-flex align-items-center  text-nowrap">
        <div className="col-lg-10 col-md-12 p-0 ">
          <div className="d-flex gap-5 py-2">
            <span href="" onClick={() => setActiveTab("active_clients")}>
              <p
                className={`tab-active-members mb-0 ${activeTab === "active_clients" && "campaign_header_tab_active"}`}
              >
                Active Members ({membersCount?.active})
              </p>
              {activeTab === "active_clients" && (
                <div style={{ border: "solid 1px #7f56d9" }}> </div>
              )}
            </span>

            <span href="" onClick={() => setActiveTab("blocked_clients")}>
              <p
                className={`tab-blocked-members mb-0 ${activeTab === "blocked_clients" && "campaign_header_tab_active"}`}
              >
                Blocked Members ({membersCount?.blocked})
              </p>
              {activeTab === "blocked_clients" && (
                <div style={{ border: "solid 1px #7f56d9" }}> </div>
              )}
            </span>

            <span href="" onClick={() => setActiveTab("pending_clients")}>
              <p
                className={`tab-onboarding-members mb-0 ${activeTab === "pending_clients" && "campaign_header_tab_active"}`}
              >
                Onboard Pending Members ({membersCount?.pending}){" "}
              </p>
              {activeTab === "pending_clients" && (
                <div style={{ border: "solid 1px #7f56d9" }}> </div>
              )}
            </span>

            <div className="d-flex py-lg-1 px-3 d-flex align-items-center bg-white gap-2  rounded filter-by-role">
              <label htmlFor="">Filter User By:</label>
              <Select
                onChange={(selected_option) => {
                  setFilter(selected_option);
                }}
                value={filter}
                styles={customStyles}
                isSearchable={true}
                options={[
                  { label: "All", value: 0 },
                  { label: "Admin", value: 1 },
                  { label: "Member", value: 3 },
                ]}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-2 col-md-12 d-flex justify-content-lg-end p-0 btn-create-member">
          {(user?.role_id === 2 || user?.role_id === 1) &&
            user?.total_members > membersCount?.active &&
            user?.status && (
              <NavLink
                to="/client/settings/add_user"
                className="btn btn-md  rounded-pill text-center  btn-primary "
              >
                Create Member
              </NavLink>
            )}
        </div>
      </div>
      {activeTab === "pending_clients" && (
        <div
          style={{
            fontFamily: "aeonik_medium",
          }}
        >
          <p className="">
            Once the member completes onboarding process it will be listed in{" "}
            <span className="text-success ">Active Members List.</span>{" "}
          </p>
        </div>
      )}

      <div className="card campaign_card position-relative  ">
        <div className="d-flex justify-content-between align-items-center  campaign_card_heading ">
          <p className="mb-0">Members List</p>
        </div>
        {/* users list */}
        {loading ? (
          <div className="position-absolute top-50 end-50">
            <LoadingSpinner />
          </div>
        ) : (
          userList?.length > 0 &&
          userList?.map((user) => {
            return (
              <UserCard key={user?.user_id} user={user} activeTab={activeTab} />
            );
          })
        )}
        {!loading && userList.length == 0 && (
          <div style={{ position: "absolute", left: "37%", top: "50%" }}>
            <div>
              <h5>No Members To Display</h5>
            </div>
          </div>
        )}
      </div>
      <div className="">
        <ul className="pagination justify-content-center">
          <li
            className={`page-item ${page_details?.current_page <= 1 && "disabled"} `}
            onClick={() => {
              page_details?.current_page > 0 &&
                setPageDeatils({
                  ...page_details,
                  current_page: page_details?.current_page - 1,
                });
            }}
          >
            <span className="page-link">Previous</span>
          </li>
          {Array.from(
            { length: page_details?.last_page },
            (_, index) => index + 1,
          ).map((page) => {
            return (
              <li
                key={page}
                className={`page_item ${page_details?.current_page === page && "active"}`}
                onClick={() => {
                  setPageDeatils({ ...page_details, current_page: page });
                }}
              >
                <span className="page-link">{page}</span>
              </li>
            );
          })}
          <li
            className={`page-item ${page_details?.current_page === page_details?.last_page && "disabled"}`}
            onClick={() => {
              page_details?.current_page < page_details?.last_page &&
                setPageDeatils({
                  ...page_details,
                  current_page: page_details?.current_page + 1,
                });
            }}
          >
            <span className="page-link">Next</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Users;
